


// Window resize debounce
$(window).bind("resize", function () {
    clearTimeout(timer);
    timer = setTimeout(function () {
        $(window).resize();
    }, 250);
});

// Footer slick carousel
$(document).ready(function () {
    $("#footer-blocks-bottom-1583740409770").slick({
        infinite: true,
        slidesToShow: 4,
        arrows: false,
        slidesToScroll: 1,
        responsive: [
            { breakpoint: 992, settings: { slidesToShow: 2, autoplay: true, autoplaySpeed: 4000 } },
            { breakpoint: 768, settings: { slidesToShow: 1, autoplay: true, autoplaySpeed: 4000 } }
        ]
    });
});

// Dropdown menu label click
$(".dropdown-menu label").on("click", function () {
    $(this).parents(".dropdown").removeClass("open");
    var value = $(this).find("input").val();
    $(".dropdown-menu label").not(this).parents("li").removeClass("active");
    $(".dropdown-toggle .plc").text(value).addClass("bld");
});

// Body click to close submenu
$("body").click(function (event) {
    if (event.target.id !== "subMenu") {
        if (!$(event.target).closest("#subMenu").length) {
            $(".close-mega-sub-menu").addClass("hide");
        }
    }
});

// Collapse container toggle
$(".collapse-container").on("click", ".collapse-trigger", function (event) {
    event.preventDefault();

    if ($(this).hasClass("with-icon")) {
        $(this).find("i").toggleClass("aDown");
    }

    var container = $(this).parents(".collapse-container");
    container.toggleClass("reveal");
    $(this).siblings(".collapse-hide").slideToggle("slow");

    if ($(this).hasClass("after-text")) {
        var defaultText = $(this).attr("data-default-text");
        var afterText = $(this).attr("data-after-text");
        container.hasClass("reveal") ? $(this).text(afterText) : $(this).text(defaultText);
    }
});

// Sticky main menu on scroll
$(function () {
    var menuHeight = $(".main-menu-container").height() + "px";
    var menuContainer = $(".main-menu-container");

    $(window).scroll(function () {
        var scrollTop = $(window).scrollTop();

        if (scrollTop >= 364) {
            menuContainer.addClass("fixed");
            $("#after-main-menu").css("margin-top", menuHeight);

            if (scrollTop >= 404) {
                menuContainer.addClass("show");
            } else {
                menuContainer.removeClass("show");
            }
        } else {
            menuContainer.removeClass("fixed");
            $("#after-main-menu").css("margin-top", 0);
        }
    });
});

// Close mega submenu
$(".close-mega-sub-menu").click(function () {
    $(".with-sub-menu").removeClass("active");
    $(this).addClass("hide");
});

// With-sub-menu click
$(".with-sub-menu > a").click(function () {
    $(".type-menu-collection").removeClass("show-menu");
});

// Activated submenu link click
$("ul.megamenu > li.click li.activated li a").click(function () {
    var parentMenu = $(this).parents(".with-sub-menu");
    parentMenu.addClass("hide-submenu");
    $(".type-menu-collection").addClass("show-menu");

    setTimeout(function () {
        parentMenu.removeClass("active hide-submenu");
    }, 500);

    var targetId = "#" + $(this).attr("href").split("#")[1];
    $("html, body").animate({ scrollTop: $(targetId).offset().top - 100 }, 800, "swing");
});

// Deactivated/activated submenu link click
$("ul.megamenu > li.click li.deactivated a, ul.megamenu > li.click li.activated > a").click(function () {
    window.location = $(this).attr("href");
});

// Scroll to hash if present
if (window.location.hash) {
    var hash = window.location.hash;
    $("html, body").animate({ scrollTop: $(hash).offset().top - 50 }, 2000, "swing");
}

var timer;
function showError(t) {
    var e;
    for (
        jQuery(window).trigger("resize").trigger("scroll"),
            $(".delivery-pickup .spinner-1").hide(),
            $(".check-result-container").slideDown("slow"),
            e = t.length - 1;
        e >= 0;
        e--
    )
        $(".delivery-check-result").html("<p style='color: #F8ACAC'>" + t[e] + "</p>");
}
$("#playyoutube").on("click", function (t) {
    ($("#youtube-video")[0].src += "&autoplay=1"),
        $(".tp-parallax-wrap").fadeOut(600, "linear", function () {
            $(".youtube-still").addClass("playing");
        }),
        t.preventDefault();
}),
    $(".slide-trigger").on("click", function (t) {
        var e = "#" + $(this).attr("data-target");
        $(e).slideToggle("fast"), t.preventDefault();
    }),
    $(".trigger-delivery-info").click(function () {
        $(this).toggleClass("active"), $(this).attr("data-target");
        var t = $(this).parents("p").next();
        t.toggleClass("hide"),
            $(".delivery-info").not(t).addClass("hide"),
            $(".trigger-delivery-info").not(this).removeClass("active");
    });
var isOutOfViewport = function (t) {
    var e = t.getBoundingClientRect(),
        i = {};
    return (
        (i.top = e.top < 0),
        (i.left = e.left < 0),
        (i.bottom = e.bottom > (window.innerHeight || document.documentElement.clientHeight)),
        (i.right = e.right > (window.innerWidth || document.documentElement.clientWidth)),
        (i.any = i.top || i.left || i.bottom || i.right),
        i
    );
};
$(window).load(function () {
    0 != $("map").length &&
        $("area").each(function (t) {
            var e = $(this).parents("map").attr("id") + "-source";
            $(this).parents("map").siblings("img").attr("id", e);
            var i = document.getElementById(e).naturalWidth,
                a = document.getElementById(e).naturalHeight,
                o = $(this).attr("coords").split(","),
                s = $(this).attr("data-info"),
                n = o[0] / (i / 100),
                l = o[1] / (a / 100);
            (n = n.toFixed(3)), (l = l.toFixed(3));
            var r = $(this).attr("data-position").split(","),
                c = $(this).parents("map");
            $(c).append(
                "<div class='reveal " +
                    r[0] +
                    "' id='area-" +
                    t +
                    "' style='left:" +
                    n +
                    "%;top:" +
                    l +
                    "%;left:" +
                    o[0] +
                    "; top:" +
                    o[1] +
                    "'><div class='wrapper-mapping'><span class='ring ring-1'></span><span class='ring ring-2'></span><span class='ring ring-3'></span> <button class='btn'><span class='plus-minus-toggle collapsed'></span></button> </div></div>"
            );
            var p = $(this).attr("data-width");
            "" == p &&
                ($(c).append("<div class='info' id='infoarea-" + t + "' style='width: auto'>" + s + "</div>"),
                (p = $("#infoarea-" + t).innerWidth() + 1)),
                $("#infoarea-" + t).remove(),
                $(c).on("click", "#area-" + t, function (t) {
                    0 != $("map .info").length &&
                        $("map .info")
                            .fadeOut(300)
                            .animate({ top: "+=5%" }, { queue: !1, duration: 500 })
                            .queue(function () {
                                $(this).remove();
                                var t = "#" + $(this).attr("id").substring(4, $(this).attr("id").length);
                                $(t).find(".plus-minus-toggle").addClass("collapsed");
                            }),
                        $("map .reveal").not(this).removeClass("active"),
                        $(this).toggleClass("active"),
                        $(this).find(".plus-minus-toggle").toggleClass("collapsed");
                    var e,
                        i = $(this).attr("id");
                    if ("top" == r[0]) {
                        (positionTemp =
                            "left: calc(" + n + "% - ((" + p + "px - 32px) / 2));top:calc(" + l + "% - 18px )"),
                            $(c).append(
                                "<div class='info checkviewport' id='info' style='" +
                                    positionTemp +
                                    ";width:" +
                                    p +
                                    "px;'>" +
                                    s +
                                    "</div>"
                            );
                        var a = document.querySelector("#info");
                        isOutOfViewport(a).any
                            ? (console.log("Not in the viewport! =("), (e = "left: 5px;top:calc(" + l + "% - 18px )"))
                            : (e = "left: calc(" + n + "% - ((" + p + "px - 32px) / 2));top:calc(" + l + "% - 18px )"),
                            $("#info").remove();
                    } else if ("bottom" == r[0])
                        (e = "left: calc(" + n + "% - ((" + p + "px - 32px) / 2));top: calc(" + l + "% + 32px)"),
                            (o = "12px");
                    else if ("left" == r[0]) {
                        if (
                            ((positionTemp = "left: calc(" + n + "% - " + p + "px);top: calc(" + l + "% - 7px)"),
                            $(c).append(
                                "<div class='info checkviewport' id='info' style='margin-left: -17px;" +
                                    positionTemp +
                                    ";width:" +
                                    p +
                                    "px;'>" +
                                    s +
                                    "</div>"
                            ),
                            (a = document.querySelector("#info")),
                            isOutOfViewport(a).any)
                        ) {
                            console.log("Not in the viewport! =("),
                                $(this).removeClass("left"),
                                $(this).addClass("right"),
                                (e = "left: calc(" + n + "% + 32px);top: calc(" + l + "% - 7px)");
                            var o = "15px";
                        } else
                            $(this).removeClass("right"),
                                $(this).addClass("left"),
                                (e = "left: calc(" + n + "% - " + p + "px);top: calc(" + l + "% - 7px)"),
                                (o = "-17px");
                        $("#info").remove();
                    } else
                        "right" == r[0]
                            ? ((positionTemp = "left: calc(" + n + "% + 32px);top: calc(" + l + "% - 7px)"),
                              $(c).append(
                                  "<div class='info checkviewport' id='info' style='margin-left: 15px;" +
                                      positionTemp +
                                      ";width:" +
                                      p +
                                      "px;'>" +
                                      s +
                                      "</div>"
                              ),
                              (a = document.querySelector("#info")),
                              isOutOfViewport(a).any
                                  ? (console.log("Not in the viewport! =("),
                                    (e =
                                        "left: calc(" +
                                        n +
                                        "% + 32px);top: calc(" +
                                        l +
                                        "% - 7px); width: auto; margin-right: 5px"),
                                    (o = "10px"))
                                  : ((e = "left: calc(" + n + "% + 32px);top: calc(" + l + "% - 7px)"), (o = "15px")),
                              $("#info").remove())
                            : "righttobottom" == r[0]
                              ? ((e = "left: calc(" + n + "% + 45px);top:" + l + "%"),
                                (o = "0px"),
                                1 != r.length && (o = parseInt(r[1]) + "px"))
                              : "lefttobottom" == r[0]
                                ? ((e = "left: calc(" + n + "% - " + p + "px - 18px);top:" + l + "%"),
                                  (o = "0px"),
                                  1 != r.length && (o = parseInt(r[1]) + "px"))
                                : "righttotop" == r[0] &&
                                  ((e = "left: calc(" + n + "% + 45px);top: calc(" + l + "% - 10px)"),
                                  (o = "0px"),
                                  1 != r.length && (o = "-" + parseInt(r[1]) + "px"));
                    $(c).append(
                        "<div class='info' id='info" + i + "' style='width:" + p + "px;" + e + ";'>" + s + "</div>"
                    ),
                        "left" == r[0] || "right" == r[0]
                            ? $("#info" + i)
                                  .fadeIn(500)
                                  .animate({ marginLeft: o }, { queue: !1, duration: 500 })
                            : ("top" == r && (o = "-" + ($("#info" + i).outerHeight() - 8) + "px"),
                              $("#info" + i)
                                  .fadeIn(500)
                                  .animate({ marginTop: o }, { queue: !1, duration: 500 })),
                        t.stopPropagation();
                }),
                $(c).on("click", ".info", function (t) {
                    t.stopPropagation();
                }),
                $(document).on("click", function (t) {
                    0 != $("map .info").length &&
                        $("map .info")
                            .fadeOut(300)
                            .animate({ top: "+=5%" }, { queue: !1, duration: 500 })
                            .queue(function () {
                                $(this).remove();
                            }),
                        $("map .reveal").removeClass("active"),
                        $("map .plus-minus-toggle").addClass("collapsed");
                });
        });
}),
    $(function () {
        var t = $(".type-menu-collection");
        $(window).scroll(function () {
            var e = $(window).scrollTop();
            e >= 420
                ? (t.addClass("fixed"), e >= 460 ? t.addClass("show-menu") : t.removeClass("show-menu"))
                : t.removeClass("fixed");
        });
    }),
    $(function () {
        var t = $("section"),
            e = $("nav a");
        t.waypoint({
            handler: function (t) {
                var i;
                (i = $(this)), "up" === t && (i = i.prev());
                var a = $('nav a[href="#' + i.attr("id") + '"]');
                e.parent().removeClass("active"), a.parent().addClass("active");
            },
            offset: "35%",
        });
    });
var url = document.location.toString();
if (url.match("#")) {
    var tabDestination = $('.nav-tabs a[href="#' + url.split("#")[1] + '"]');
    tabDestination.tab("show"),
        tabDestination.addClass("disabled"),
        "" != url.split("#")[1] &&
            ($("#nav-tabContent .tab-pane.active").addClass("force-hide"),
            $("#nav-tabContent #" + url.split("#")[1]).addClass("force-show"));
}
function boMssgChange(t) {
    var e = "." + $(t).find("option:selected").text() + "_" + t.value;
    $("." + t.attributes.data_id.value + " li").addClass("hide"),
        $("." + t.attributes.data_id.value + " li" + e).removeClass("hide");
}
$(".nav-tabs a").on("click", function () {
    $(this).hasClass("disabled") ||
        ($("#nav-tabContent .tab-pane").removeClass("force-hide force-show"), $(".nav-tabs a").removeClass("disabled"));
}),
    $(".html5-video-trigger").click(function () {
        var t = $("#" + $(this).attr("data-video"));
        (t = t.get(0)),
            $(this).hasClass("pause-btn")
                ? (t.play(), $(this).hide(), $(this).siblings().show())
                : (t.pause(), $(this).hide(), $(this).siblings().show());
    }),
    $(".next-compare").on("click", function () {
        var t = (($(".product-compare table tr:first-child td").length - 1) / 2).toFixed(),
            e = parseInt($(this).attr("data-current"));
        e == t ? $(this).attr("data-current", 1) : $(this).attr("data-current", e + 1),
            $(".product-compare table tr td:not(:first-child)").hide();
        var i = e + e,
            a = i + 1;
        $(".product-compare table tr td:nth-child(" + i + ")").show(),
            $(".product-compare table tr td:nth-child(" + a + ")").show(),
            console.log("I am clicked " + t);
    }),
    $(".needhelp-headerinner").on("click", function (t) {
        t.preventDefault(),
            $(".need-help-gorgias").addClass("needhelp-transition"),
            setTimeout(function () {
                $(".need-help-gorgias").hide();
            }, 200);
    });
